import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../../pages/auth/services/auth.service';

export const loggedInAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const isAuthenticated = authService.isLoggedIn();
  if (isAuthenticated) {
    router.navigate(['/']);
  }
  return true;
};
